import {
  FF_BRAZE_CONTENT_CARDS,
  FF_DATADOG_SESSION_REPLAY_SAMPLE_RATE,
  FF_ENABLE_BEGIN_ESCRIPT_SIGNUP,
  FF_ENABLE_CLICK_COLLECT_SHIPPING_OPTION,
  FF_ENABLE_CONCESSION_AWARENESS_CHECKOUT,
  FF_ENABLE_CONCESSION_DISCOUNT_BANNER,
  FF_ENABLE_ERX_STATUS_DISPLAY,
  FF_ENABLE_ESCRIPT_ORDERS,
  FF_ENABLE_GOOGLE_PLACES_UMEDS,
  FF_ENABLE_MFA_SETUP,
  FF_ENABLE_ORDER_PRODUCT_TAX_DISCLAIMER,
  FF_ENABLE_PATIENT_ORDERS_WHITE_LABEL_IMAGES,
  FF_ENABLE_SHOPIFY_CHECKOUT,
  FF_ENABLE_UMEDS_CHATBOT,
  FF_ESCRIPT_ENABLE_PRESCRIPTIONS_PAGES,
  FF_ESCRIPT_NEW_PAYMENT_SUCCESS_PAGE,
  FF_ESCRIPT_RECONCILE_PRESCRIPTIONS,
  FF_PATIENT_REFILL_CHECKOUT_BANNER_TEXT,
  FF_REFUND_NON_REFUND_CREDIT,
  FF_SHIPPING_OPTIONS_ALLOW_DISPLAY_OF_SAME_DAY_AFTERNOON_OPTION,
  FF_SHIPPING_PRICE,
  FF_SHOPIFY_REDIRECT_THANK_YOU_PAGE,
  FF_SHOW_MAINTENANCE_SCREEN,
  FF_SHOW_PAYMENT_WARNING,
  FF_UPDATED_PATIENT_ORDER_STATUSES,
} from '@/constants/featureFlags';
import type { FeatureFlags } from './types';

const ffDefaults = {
  [FF_ENABLE_SHOPIFY_CHECKOUT]: true,
  [FF_REFUND_NON_REFUND_CREDIT]: false,
  [FF_SHIPPING_PRICE]: 13.64,
  [FF_SHOW_PAYMENT_WARNING]: 'OFF',
  [FF_SHOW_MAINTENANCE_SCREEN]: false,
  [FF_UPDATED_PATIENT_ORDER_STATUSES]: false,
  [FF_ENABLE_PATIENT_ORDERS_WHITE_LABEL_IMAGES]: false,
  [FF_ENABLE_GOOGLE_PLACES_UMEDS]: false,
  [FF_SHOPIFY_REDIRECT_THANK_YOU_PAGE]: false,
  [FF_PATIENT_REFILL_CHECKOUT_BANNER_TEXT]:
    'Please note: vaporiser devices and batteries are now no longer available due to a change in legislation. If impacted, book a follow-up appointment with your doctor to discuss alternatives.',
  [FF_ENABLE_CONCESSION_DISCOUNT_BANNER]: false,
  [FF_ENABLE_CONCESSION_AWARENESS_CHECKOUT]: false,
  [FF_ENABLE_ESCRIPT_ORDERS]: true,
  [FF_DATADOG_SESSION_REPLAY_SAMPLE_RATE]: 50,
  [FF_ESCRIPT_NEW_PAYMENT_SUCCESS_PAGE]: false,
  [FF_ENABLE_UMEDS_CHATBOT]: false,
  [FF_ENABLE_BEGIN_ESCRIPT_SIGNUP]: false,
  [FF_BRAZE_CONTENT_CARDS]: false,
  [FF_ESCRIPT_RECONCILE_PRESCRIPTIONS]: false,
  [FF_ENABLE_MFA_SETUP]: false,
  [FF_ENABLE_CLICK_COLLECT_SHIPPING_OPTION]: false,
  [FF_SHIPPING_OPTIONS_ALLOW_DISPLAY_OF_SAME_DAY_AFTERNOON_OPTION]: false,
  [FF_ESCRIPT_ENABLE_PRESCRIPTIONS_PAGES]: false,
  [FF_ENABLE_ERX_STATUS_DISPLAY]: false,
  [FF_ENABLE_ORDER_PRODUCT_TAX_DISCLAIMER]: false,
} satisfies Partial<FeatureFlags>;

export default ffDefaults;
